export const numbers="0123456789"
export const uppercaseLetters="ABCDEFGHIJKLMNOPQRSTUVWXYZ"
export const lowercaseLetters="abcdefghijklmnopqrstuvwxyz"
export const specialCharacters = "!'^+%&/()=?_#$½§{[]}|;:>÷`<.*-@é"